"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CivicStoryCard = _interopRequireDefault(require("../CivicStoryCard/CivicStoryCard"));

var _cardMetaTypes = _interopRequireDefault(require("./cardMetaTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CivicCardLayoutClassic(_ref) {
  var isLoading = _ref.isLoading,
      data = _ref.data,
      cardMeta = _ref.cardMeta;
  return _react["default"].createElement(_CivicStoryCard["default"], {
    title: cardMeta.title,
    slug: cardMeta.slug
  }, _react["default"].createElement(_react["default"].Fragment, null, cardMeta.introText, cardMeta.selector, _react["default"].createElement(cardMeta.visualization, {
    isLoading: isLoading,
    data: data
  })));
}

CivicCardLayoutClassic.propTypes = {
  isLoading: _propTypes["default"].bool,
  data: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].array]),
  cardMeta: _cardMetaTypes["default"]
};
var _default = CivicCardLayoutClassic;
exports["default"] = _default;